import { z } from "zod";

import type { AutomationSignal } from "../automation-signals";

export const AutomationSubjectSchema = z.object({
  kind: z.enum(["case", "client"]),
  id: z.string().min(1),
});
export type AutomationSubject = z.infer<typeof AutomationSubjectSchema>;

const SubjectDataSchema = z.object({
  contextType: z.enum(["case", "client"]).optional(),
  contextId: z.string().optional(),
  caseId: z.string().nullish(),
  clientId: z.string().optional(),
});

/**
 * The case or client a signal's run belongs to, for access checks and the
 * subject's Fluxo tab. Task signals belong to their context; document signals
 * to their case, falling back to their client.
 */
export const signalSubject = (signal: AutomationSignal): AutomationSubject | null => {
  const data = SubjectDataSchema.parse(signal.data);

  if (data.contextType && data.contextId) return { kind: data.contextType, id: data.contextId };
  if (data.caseId) return { kind: "case", id: data.caseId };
  if (data.clientId) return { kind: "client", id: data.clientId };
  return null;
};
